import { createAction, props } from '@ngrx/store';
import { Order } from '@shared/models/order';

export const resetAuthorizationKey = createAction(
  '[Orders] Reset Authorization Key',
  props<{ esetSubscriptionId: number; disconnectSeats: boolean }>(),
);

export const resetAuthorizationKeySuccess = createAction(
  '[Orders] Reset Authorization Key Success',
  props<{ order: Order }>(),
);

export const resetAuthorizationKeyFailure = createAction(
  '[Orders] Reset Authorization Key Failure',
  props<{ error: any }>(),
);
